let alert = (actionData) => {
    let alertTemplate = `
        <div class="alert alert-${actionData.type} alert-dismissible fade show" role="alert">
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true"><i class="fal fa-times"></i></span>
            </button>
            <strong>${actionData.title}</strong> ${actionData.message}
        </div>
    `;
    $('#smart-alerts').append(alertTemplate);
};

export default alert;
